import React from 'react';
import './bubbles.scss';

const Bubbles = () => {
  return (
    <ul className="bg-bubbles">
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
    </ul>
  );
};

export default Bubbles;



// WEBPACK FOOTER //
// ./src/components/VerticalTimeline/Bubbles.js